const { connect } = require('react-redux');
const { context } = require('app-context');
const { push: Push } = require('connected-react-router');

const OffersPage = require('../components/OffersPage');

const selectors = context.selectors.all;

module.exports = connect(
    (state) => ({
        offers: selectors.getOffers(state),
        isLoading: selectors.getIsLoadingOffers(state)
    }),
    (dispatch) => ({
        onNavigateToDetail: (offerId) => dispatch(Push(`/app/offers/${offerId}?fromList=true`))
    })
)(OffersPage);
